import { useSupplierListContext } from "../SupplierListContext";
import { AutoGrid } from "src/components/Grid/layout/AutoGrid";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

const SuppliersGrid = () => {
    const isProductUxV2 = useIsProductUxV2();
    const {
        mrt_columns,
        gridKey,
        gridConfiguration,
        suppliers = [],
        isReady,
        isRefetching,
        totalItems,
        appSearch,
        menuItems,
        pagination,
    } = useSupplierListContext();

    const isLoading = isReady === false || isRefetching === true;

    return (
        <AutoGrid
            appearance={isProductUxV2 ? "hub" : undefined}
            enableColumnsAction
            gridKey={gridKey}
            columns={mrt_columns}
            data={suppliers}
            isLoading={isLoading}
            totalItems={totalItems}
            searchParams={appSearch}
            menuItems={menuItems}
            columnsConfig={gridConfiguration}
            pagination={pagination}
        />
    );
};

export default SuppliersGrid;
